var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.09091 18C4.07 18 0 13.9707 0 9C0 4.0293 4.07 2.53646e-06 9.09091 2.53646e-06C10.5024 -0.00104728 11.8947 0.323798 13.1572 0.94873C14.4197 1.57366 15.5176 2.48146 16.3636 3.6H13.9C12.8502 2.68359 11.5556 2.08652 10.1716 1.88046C8.7875 1.6744 7.37279 1.86809 6.09717 2.43829C4.82155 3.0085 3.73923 3.93099 2.98006 5.09507C2.2209 6.25915 1.81715 7.61538 1.81727 9.001C1.81739 10.3866 2.22136 11.7428 2.98072 12.9067C3.74008 14.0707 4.82256 14.993 6.09827 15.563C7.37399 16.133 8.78874 16.3264 10.1728 16.1202C11.5568 15.9139 12.8513 15.3166 13.9009 14.4H16.3645C15.5184 15.5187 14.4204 16.4265 13.1577 17.0515C11.8951 17.6764 10.5026 18.0012 9.09091 18ZM15.4545 12.6V9.9H8.18182V8.1H15.4545V5.4L20 9L15.4545 12.6Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d8b871615c9087c134544a5b4d86fbec.svg";
export { ForwardRef as ReactComponent };